module.exports = __webpack_public_path__ + "img/bo.ba3aba41.svg";